<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称" >
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow ></my-button>
				</el-form-item>

			</el-form>
		</el-col>
        <div style="margin-top: 20px;">
            <el-table :data="dataList" border highlight-current-row v-loading="listLoading" style="width: 100%;" :height="formHeight"  size="small" >
                <el-table-column type="index" label="序号"  ></el-table-column>
                <el-table-column prop="no" label="测点编号"  ></el-table-column>
                <el-table-column prop="address" label="测点位置" ></el-table-column>
                <el-table-column prop="people" label="监测人" ></el-table-column>
                <el-table-column prop="queue" label="区域" >
					<template slot-scope="scope">
						<span v-if="scope.row.queueId==1" >一类</span>
						<span v-else-if="scope.row.queueId==2" >二类</span>
					</template>
				</el-table-column>
                <el-table-column prop="startTime" label="开始时间" ></el-table-column>
                <el-table-column prop="endTime" label="结束时间" ></el-table-column>
                <el-table-column prop="status" label="状态"  >
					<template slot-scope="scope">
						<span v-if="scope.row.status==1" >已计算</span>
						<span v-else-if="scope.row.status==0" >未计算</span>
					</template>
				</el-table-column>

                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <table-update-button  @select-type="handleEdit(scope.$index, scope.row)" ></table-update-button>
                    </template>
                </el-table-column>                
            </el-table>

            	<!--工具条-->
            <el-col :span="24" class="toolbar">
                <el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :page-sizes="[10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page">
                </el-pagination>
            </el-col>
        </div>

		<!--From界面-->
		<el-dialog title="修改" :visible.sync="formVisible" :close-on-click-modal="false" width="60%" top="5vh">
			<el-form :model="formSetData" label-width="120px" :rules="formRules" ref="formSetData" >
				<el-form-item label="测点编号" prop="no">
					<el-input v-model="formSetData.no" ></el-input>
				</el-form-item>
				<el-form-item label="测点位置"  prop="address" >
					<el-input v-model="formSetData.address" ></el-input>
				</el-form-item>
				<el-form-item label="监测人"  prop="people" >
					<el-input v-model="formSetData.people" ></el-input>
				</el-form-item>
				<el-form-item label="区域"  prop="queueId">
					<el-select v-model="formSetData.queueId" placeholder="请选择区域">
						<el-option label="一类" :value="1"></el-option>
						<el-option label="二类" :value="2"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="submitData" :loading="loading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import { getProjects,getDevicesByProjectId,selectMonitoringRecord} from '../../api/api';

	import myButton from '../../components/myButton/index.vue'

    import TableUpdateButton from '../../components/myButton/TableUpdateButton.vue'

	export default {
		props: {
            collapsed: {
                type: Boolean,
            },
        },
		components: { myButton ,TableUpdateButton},
		data() {
			return {
				filters: {
					projectId:"",
					mn:"",
					time:[]
				},
				total: 0,
				page:1,
				pageSize:10,
				listLoading: false,
				dataList:[
					{
						"id": 1,
						"mn": "YS700124010003",
						"startTime": "2024-10-23 08:50:44",
						"endTime": "2024-10-24 22:50:47",
						"lng": 36.284679,
						"lat": 120.457176,
						"status": 1,
						"no": null,
						"address": null,
						"people": null,
						"queueId": null,
						no:"001",address:"北门",leqbj:"49",date:"2024年8月9日",people:"测试员",ta:"23",ua:"56",ws:"0",wd:"北风",devicename:"便携噪声",queueId:1
					},
					{
						"id": 2,
						"mn": "YS700124010003",
						"startTime": "2024-11-01 08:30:00",
						"endTime": "2024-11-05 23:00:00",
						"lng": 36.284679,
						"lat": 120.457176,
						"status": 0,
						"no": null,
						"address": null,
						"people": null,
						"queueId": null,
						no:"002",address:"南门",leqbj:"49",date:"2024年8月9日",people:"测试员",ta:"23",ua:"56",ws:"0",wd:"北风",devicename:"便携噪声",queueId:2
					},
				],
				firstFlag:true,
				devices:[],
				facList:[],
				projects:[],
				formHeight:0,

				type:sessionStorage.getItem("type"),

				formVisible:false,
				loading:false,
				formSetData:{},
				formRules: {
					no: [
                        { required: true, message: '请输入测点编号', trigger: 'blur' }
					],
					address: [
                        { required: true, message: '请输入测点地址', trigger: 'blur' }
					],
					people:[
						{ required: true, message: '请输入监测人', trigger: 'blur' }
					],
                    queueId: [
						{  required: true, message: '请选择区域', trigger: 'change'}
					],
				},
			}
			
		},
		methods: {
			cancleSubmit(){
				this.formVisible=false;
			},
            handleEdit(i,row){
				this.formVisible=true;
				if( this.$refs.formSetData!=undefined){
               		this.$refs.formSetData.resetFields();
				}
				this.formSetData = Object.assign({}, row);
            },
			submitData(){
				this.$refs.formSetData.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;
                            let para = Object.assign({}, this.formSetData);
							this.$message({
								message: '修改成功',
								type: 'success'
							});
							this.loading = false;
							this.formVisible = false;    
							return;
                            updateDevice(para).then((res) => {//todo  接口待修改
								this.loading = false;
                               	let resData = res.data;
								if (resData.Result != true) {
									this.$message({
									message: resData.msg,
									type: 'error'
								})}else{
									this.$message({
										message: '修改成功',
										type: 'success'
									});
								}
                                this.formVisible = false;                                
                                this.getDataList(1);
                            });
						});
					}
				});
			},
			cancle(){
				this.formVisible=false;
			},
			clickBtn(type){
				if(type=="query"){
					this.getDataList(1);
				}
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getDataList(0);
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getDataList(1);
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
			//获取设备列表
			getDevices() {
                  let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
					//如果当前已选的设备不属于选中的项目，把设备置空
					if(this.devices.length>0){
						this.filters.mn=this.devices[0].mnCode;
					}
					if(this.firstFlag){
						this.firstFlag=false;
						this.getDataList(1);
					}
				});
            },
			//获取历史数据信息
			getDataList(type){
				return;
				if(type==1){//换条件后重新查询，页数改为第一条
					this.page=1;
				}

				let para = {
					pageNum: this.page,
					pageSize:this.pageSize,
                    mn: this.filters.mn,
				};
				this.listLoading = true;
				selectMonitoringRecord(para).then((res) => {
					this.listLoading = false;
					if(res.data.code!=200){
                        this.$message({
                            message: "查询失败，请重试",
                            type: 'error'
                        })
						return;
                    }

					this.dataList=res.data.data.records;
                    this.total=res.data.data.total;
				}).catch(() => {
					this.listLoading = false;
				});
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			},
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)

			this.getProjects();
		}
	}

</script>

<style>
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }

	.dataTab{
		margin: 10px;
		margin-top: 0;
		cursor: pointer;
		color: #409eff;
		background: #d9edf7;
	}
	.tabSelect{
		color: #fff;
		background: #409eff;
	}
</style>


// WEBPACK FOOTER //
// FlightSet.vue?6b92cb27